module.exports = __webpack_public_path__ + "img/jdb-long-min.db31b35a.png";